/* eslint-disable no-undef */
// eslint-disable-next-line no-unused-vars
const _fbq = (...args) => {
  if (typeof fbq !== 'function') {
    return;
  }

  fbq(...args);
};

export default {};
